import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const Card = ({ title, description, children, ...props }) => {
	return (
		<div className="card" {...props}>
			{title ? <div className="card-title">{title}</div> : null}
			{title ? <div className="card-description">{description}</div> : null}
			<div className="card-subcard">{children}</div>
		</div>
	);
};

Card.propTypes = {
	title: PropTypes.node,
	description: PropTypes.node,
	children: PropTypes.node
};

export default Card;
